import PricingTooltip from './PricingTooltip'
import styles from './PricingTable.module.css'

export default function PricingTable({
    id,
    label,
    columns,
    groups,
    variant = 'comparison',
    onTalkToSales,
}) {
    return (
        <div
            role="region"
            aria-label={label}
            tabIndex={0}
            className={`${styles.wrapper} focus-visible:outline-primary`}>
            <table
                className={`${styles.table} ${
                    variant === 'perPiece' ? styles.perPiece : ''
                }`}>
                <caption className="sr-only">{label}</caption>
                <thead>
                    <tr>
                        {columns.map((column) => (
                            <th key={column.label} scope="col">
                                {column.label}
                                {column.price && (
                                    <span className={styles.price}>
                                        {column.price}
                                    </span>
                                )}
                            </th>
                        ))}
                    </tr>
                </thead>
                {groups.map((group, groupIndex) => (
                    <tbody key={group.title}>
                        <tr>
                            <th
                                id={group.id}
                                scope="rowgroup"
                                colSpan={columns.length}
                                className={styles.category}>
                                {group.title}
                            </th>
                        </tr>
                        {group.rows.map((row, rowIndex) => (
                            <tr key={`${row.label}-${row.subtitle}`}>
                                <th scope="row" className={styles.feature}>
                                    {row.label}
                                    {row.subtitle && (
                                        <span className={styles.subtitle}>
                                            {' '}
                                            {row.subtitle}
                                        </span>
                                    )}
                                    {row.tooltip && (
                                        <PricingTooltip
                                            id={`${id}-tip-${groupIndex}-${rowIndex}`}
                                            text={row.tooltip}
                                            label={row.label}
                                        />
                                    )}
                                </th>
                                {row.values.map((value, index) => (
                                    <td
                                        key={columns[index + 1].label}
                                        className={styles.value}>
                                        {typeof value === 'boolean' ? (
                                            <span
                                                aria-label={
                                                    value
                                                        ? 'Included'
                                                        : 'Not included'
                                                }
                                                className={
                                                    value
                                                        ? styles.yes
                                                        : styles.no
                                                }>
                                                {value ? '✓' : '–'}
                                            </span>
                                        ) : Array.isArray(value) ? (
                                            value.map((line) => (
                                                <span
                                                    key={line}
                                                    className="block">
                                                    <RateLine line={line} />
                                                </span>
                                            ))
                                        ) : (
                                            <a
                                                href={value.href}
                                                onClick={
                                                    variant === 'perPiece' &&
                                                    value.label ===
                                                        'Talk to Sales' &&
                                                    onTalkToSales
                                                        ? (event) => {
                                                              event.preventDefault()
                                                              onTalkToSales?.()
                                                          }
                                                        : undefined
                                                }
                                                className="font-extrabold text-secondary hover:underline">
                                                {value.label}
                                            </a>
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                ))}
            </table>
        </div>
    )
}

function RateLine({ line }) {
    const match = line.match(/^(.*?)\s+(FC|SC|\/record)$/)
    if (!match) return line
    return (
        <>
            {match[1]}{' '}
            <span
                className={
                    match[2] === '/record' ? styles.record : styles.postage
                }>
                {match[2]}
            </span>
        </>
    )
}
